<template>
  <div class="salaryreports__report__view">
    <b-loading :is-full-page="false" :active="loading || isLoading"></b-loading>
    <div class="reports__subheader">
      <year-month-panel @year="(value) => setYear(value)" @month="(value) => setMonth(value)" :label="'Fra Måned, År'" v-if="!showToDate"> </year-month-panel>

      <div class="schedule__daynavigator">
        <day-select-dropdown :selectedDate="getFromDate" @date-selected="(value) => setDate(value, 0)" mode="day" v-if="showToDate">
          <template #trigger="{ toggleDropdown, selectedDate }">
            <a tooltiptext tabindex="0" class="this-week-button test-this-week control-button" @click="toggleDropdown">
              <span class>
                <span class="control-button-text">{{ formatDate(selectedDate) }}</span>
              </span>
            </a>
          </template>
        </day-select-dropdown>
      </div>

      <div class="schedule__daynavigator">
        <day-select-dropdown :selectedDate="getToDate" @date-selected="(value) => setDate(value, 1)" mode="day" v-if="showToDate">
          <template #trigger="{ toggleDropdown, selectedDate }">
            <a tooltiptext tabindex="0" class="this-week-button test-this-week control-button" @click="toggleDropdown">
              <span class>
                <span class="control-button-text">{{ formatDate(selectedDate) }}</span>
              </span>
            </a>
          </template>
        </day-select-dropdown>
      </div>

      <submit-panel @submit="fetchAndApplyFilter" class="no-print"> </submit-panel>

      <b-dropdown aria-role="list" style="margin-top: 20px;margin-left: 20px;float:right;">
        <template #trigger="{ active }">
          <b-button style="height: 28px !important;" label="Handlinger" type="is-primary" :icon-right="active ? '' : ''" />
        </template>

        <b-dropdown-item aria-role="listitem" @click="() => { setShowYearTotal(!showYear); }" v-bind:style="showYear ? 'background: darkgray;' : ''">Vis års rapport</b-dropdown-item>
        <b-dropdown-item aria-role="listitem" @click="() => { modelUpdated(); setCompareDate(!compareDate); }"  v-bind:style="compareDate ? 'background: darkgray;' : ''">Vis sammenligning (forrige år)</b-dropdown-item>
        <b-dropdown-item aria-role="listitem" @click="() => { setShowToDate(!showToDate); }" v-bind:style="showToDate ? 'background: darkgray;' : ''" v-if="isAdmin">Vis dato vælger</b-dropdown-item>
        <b-dropdown-item aria-role="listitem" @click="() => { exportCsv(false); }" v-if="isAdmin">Eksport Total</b-dropdown-item>
        <b-dropdown-item aria-role="listitem" @click="() => { exportCsv(true); }" v-if="isAdmin">Eksport Antal Enheder</b-dropdown-item>
      </b-dropdown>

      <div class="reports__panel--submit" v-if="showPanel === true && salaryReportList && salaryReportList.mergedRows && salaryReportList.mergedRows.length > 0">
        <b-button class="button is-primary" @click="setFilterSalary()">
          Filtrere Løn
        </b-button>
      </div>

      <div class="reports__panel--submit" v-if="showPanel === true && salaryReportList && salaryReportList.mergedRows && salaryReportList.mergedRows.length > 0">
        <b-button class="button is-primary" @click="setFilterEmployee()">
          Filtrere medarbejdere
        </b-button>
      </div>
    </div>

    <template>
      <div class="wrapper">
        <h2>
          Lønrapport
        </h2>
        <div style="text-align: left; margin-left: 0px;border-bottom: 1px solid darkgray;margin-top: 20px; height: 35px;">
          <h3 class="inline font-bold">
            HandyVik
          </h3>
          <b-button v-if="canEdit" type="is-primary" class="inline" style="float:right;  padding:0px 5px" @click="addNewLine('partialSumRows')">
            + linje
          </b-button>
        </div>
        <table style="width: 100%;" v-if="salaryReportList.partialSumRows">
          <tbody v-for="row in salaryReportList.partialSumRows" :value="row.value" :key="row.value">
            <tr v-show="(showEmpty || row.newLine || (row.filteredTotal && row.filteredTotal !== 0)) && row.identifier !== 'Total' && row.isSelected">
              <td class="row-name" style="text-align: left;width:400px;">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.reportRowName }}</span>
                <input v-if="(row.newLine || row.isUserDefined) && canEdit" v-model="row.reportRowName" />
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px">
                <span v-if="isAdmin === false || false === canEdit">{{ (row.filteredUnits) | salarydecimal }}</span>
                <input v-if="canEdit" style="max-width:80px" v-model="row.times" type="number" />
              </td>
              <td style="text-align: left; width: 55px; padding: 0px 5px 0px 0px">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.type }}</span>
                <select v-if="(row.newLine || row.isUserDefined) && canEdit" v-model="row.type" style="border-radius: 0px; border: 2px solid; height: 25px;">
                  <option value="gange">gange</option>
                  <option value="min.">min.</option>
                  <option value="dag(e)">dag(e)</option>
                </select>
              </td>
              <td style="text-align: right; width: 55px;">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.rate | salarydecimal }}</span>
                <input style="max-width:80px" v-if="(row.newLine || row.isUserDefined) && canEdit" v-model="row.rate" type="number" />
              </td>
              <td style="text-align: right;">
                <span v-if="isAdmin === false || false === canEdit">{{ row.filteredTotal | salarydecimal }}</span>
                <span v-if="canEdit">{{ (row.times * row.rate) | salarydecimal }}</span>
                DKK
              </td>
            </tr>
            <tr v-show="compareDate && row.totalCompare && row.totalCompare > 0 && row.filteredTotal && row.filteredTotal !== 0 && row.identifier !== 'Total' && row.isSelected" style="background: rgba(219, 218, 218, 0.341);">
              <td></td>
              <td style="color: blue;text-align: right;">
                <span>({{ row.timesCompare | salarydecimal }})</span>
              </td>
              <td style="color: blue;text-align: left; width: 55px;">
                {{ row.isMinutes ? (row.type ? row.type : "min.") : row.type ? row.type : "gange" }}
              </td>
              <td style="color: blue;text-align: right;">
                {{ row.rateCompare | salarydecimal }}
              </td>
              <td style="color: blue;text-align: right;">{{ row.totalCompare | salarydecimal }} DKK</td>
            </tr>
            <tr v-show="row.filteredTotal && row.identifier === 'Total' && row.isSelected" style="border-bottom: 2px solid black; border-top: 1px solid darkgray; font-weight: bold;">
              <td class="row-name" style="text-align: left;width:400px;">
                {{ row.reportRowName }}
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px"></td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right; width: 55px;"></td>
              <td style="text-align: right;" class="AVG">{{ row.filteredTotal | salarydecimal }} DKK</td>
            </tr>
            <!-- <tr>
              <td>{{ row }}</td>
            </tr> -->
          </tbody>
        </table>

        <div class="table-header-container">
          <h3 class="inline font-bold">
            Øvrige
          </h3>
          <b-button v-if="canEdit" type="is-blue" class="inline" style="float:right; padding:0px 5px" @click="addNewLine('payrollRows')">
            + linje
          </b-button>
        </div>
        <table style="width: 100%;" v-if="salaryReportList.payrollRows">
          <tbody v-for="row in salaryReportList.payrollRows" :value="row.value" :key="row.value">
            <tr v-show="(showEmpty || row.newLine || (row.filteredTotal && row.filteredTotal !== 0)) && row.identifier !== 'Total' && row.isSelected">
              <td class="row-name" style="text-align: left;width:400px;">
                <div v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">
                  <span v-if="!row.link">{{ row.reportRowName }} </span>
                  <a v-if="row.link" target="_blank" v-bind:href="row.link" title="Klik her for at se hvor data kommer fra">{{ row.reportRowName }}</a>
                </div>
                <input v-if="(row.newLine || row.isUserDefined) && canEdit" v-model="row.reportRowName" />
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px">
                <span v-if="isAdmin === false || false === canEdit">{{ (row.filteredUnits) | salarydecimal }}</span>
                <input style="max-width:80px" v-model="row.times" type="number" v-if="canEdit" />
              </td>
              <td style="text-align: left; width: 55px; padding: 0px 5px 0px 0px">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.type }}</span>
                <select v-if="(row.newLine || row.isUserDefined) && canEdit" v-model="row.type" style="border-radius: 0px; border: 2px solid; height: 25px;">
                  <option value="gange">gange</option>
                  <option value="min.">min.</option>
                  <option value="dag(e)">dag(e)</option>
                </select>
              </td>
              <td style="text-align: right; width: 55px;">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.rate | salarydecimal }} </span>
                <input style="max-width:80px" v-if="(row.newLine || row.isUserDefined) && canEdit" v-model="row.rate" type="number" />
              </td>
              <td style="text-align: right;" v-bind:class="row.calculateGroup">
                <span v-if="isAdmin === false || false === canEdit">{{ row.filteredTotal | salarydecimal }}</span>
                <span v-if="canEdit">{{ (row.times * row.rate) | salarydecimal }}</span>
                DKK
              </td>
            </tr>
            <tr v-show="compareDate && row.totalCompare && row.totalCompare > 0 && row.filteredTotal && row.filteredTotal !== 0 && row.identifier !== 'Total' && row.isSelected" style="background: rgba(219, 218, 218, 0.341);">
              <td></td>
              <td style="color: blue;text-align: right;">
                <span>({{ row.timesCompare | salarydecimal }})</span>
              </td>
              <td style="color: blue;text-align: left; width: 55px;">
                {{ row.isMinutes ? (row.type ? row.type : "min.") : row.type ? row.type : "gange" }}
              </td>
              <td style="color: blue;text-align: right;">
                {{ row.rateCompare | salarydecimal }}
              </td>
              <td style="color: blue;text-align: right;">{{ row.totalCompare | salarydecimal }} DKK</td>
            </tr>
            <tr v-show="row.filteredTotal && row.filteredTotal > 0 && row.identifier === 'Total' && row.isSelected" style="border-bottom: 2px solid black; border-top: 1px solid darkgray; font-weight: bold;">
              <td class="row-name" style="text-align: left;width:400px">
                {{ row.reportRowName }}
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px"></td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right;"></td>
              <td style="text-align: right;">{{ row.filteredTotal | salarydecimal }} DKK</td>
            </tr>
            <!-- <tr>
              <td>{{ row }}</td>
            </tr> -->
          </tbody>
        </table>

        <div class="table-header-container">
          <h3 class="inline font-bold">
            Diverse
          </h3>
        </div>
        <table style="width: 100%;" v-if="salaryReportList.general">
          <tbody v-for="row in salaryReportList.general" :value="row.value" :key="row.value">
            <tr v-show="row.newLine || ((showEmpty || row.times !== 0) && row.identifier !== 'Total') && row.isSelected">
              <td class="row-name" style="text-align: left;width:400px;">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.reportRowName }}</span>
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px">
                <span v-if="isAdmin === false || false === canEdit">{{ row.filteredUnits | salarydecimal }} </span>
              </td>
              <td style="text-align: left; width: 55px; padding: 0px 5px 0px 0px">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.type }}</span>
              </td>
              <td style="text-align: right; width: 55px;">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.rate | salarydecimal }}</span>
              </td>
              <td style="text-align: right;">
                <span v-if="isAdmin === false || false === canEdit">{{ row.filteredTotal | salarydecimal }}</span>
                <span v-if="canEdit">{{ (row.times * row.rate) | salarydecimal }}</span>
                DKK
              </td>
            </tr>
            <tr v-show="compareDate && row.totalCompare && row.totalCompare > 0 && row.times !== 0 && row.identifier !== 'Total' && row.isSelected" style="background: rgba(219, 218, 218, 0.341);">
              <td></td>
              <td style="color: blue;text-align: right;">
                <span>({{ row.timesCompare | nodecimal }})</span>
              </td>
              <td style="color: blue;text-align: left; width: 55px;">
                {{ row.isMinutes ? (row.type ? row.type : "min.") : row.type ? row.type : "gange" }}
              </td>
              <td style="color: blue;text-align: right;">
                {{ row.rateCompare | salarydecimal }}
              </td>
              <td style="color: blue;text-align: right;">{{ row.totalCompare | salarydecimal }} DKK</td>
            </tr>
            <tr v-show="row.identifier === 'Total' && row.isSelected" style="border-bottom: 2px solid black; border-top: 1px solid darkgray; font-weight: bold;">
              <td class="row-name" style="text-align: left; width:400px">
                {{ row.reportRowName }}
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px"></td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right;"></td>
              <td style="text-align: right;">{{ row.filteredTotal | salarydecimal }} DKK</td>
            </tr>
            <!-- <tr>
              <td>{{ row }}</td>
            </tr> -->
          </tbody>
        </table>

        <div class="table-header-container">
          <h3 class="inline font-bold">
            Samlet
          </h3>
        </div>
        <table style="width: 100%;" class="total-rows" v-if="salaryReportList.totalSalaryRows">
          <tbody v-for="row in salaryReportList.totalSalaryRows" :value="row.value" :key="row.value">
            <tr v-show="(showEmpty || row.filteredTotal > 0) && row.identifier !== 'Total' && row.isSelected">
              <td class="row-name" style="text-align: left;width:400px">
                {{ row.reportRowName }}
              </td>
              <td v-show="compareDate"></td>
              <td style="text-align: right; width: 55px;padding: 0px 5px">
                <span>{{ row.filteredUnits | salarydecimal }}</span>
              </td>
              <td style="text-align: left; width: 55px;">{{ row.type }}</td>
              <td style="text-align: right; width: 55px;">
                <span v-if="specialAllowanceCanBeEdited(row.reportRowName) === false">{{ row.rate | salarydecimal }}</span>
                <input style="max-width:80px" v-if="specialAllowanceCanBeEdited(row.reportRowName)" v-model="row.rate" type="number" />
              </td>
              <td style="text-align: right;">
                <span v-if="!row.rate || row.rate === 0 || isAdmin === false || false === canEdit">{{ row.filteredTotal | salarydecimal }}</span>
                DKK
              </td>
            </tr>
            <tr v-show="row.identifier === 'Total' && row.isSelected" style="border-bottom: 2px solid black; border-top: 1px solid darkgray; font-weight: bold;">
              <td class="row-name" style="text-align: left; width:400px">
                {{ row.reportRowName }}
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px"></td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right;"></td>
              <td style="text-align: right;">{{ row.filteredTotal | salarydecimal }} DKK</td>
            </tr>
            <!-- <tr>
              <td>{{ row }}</td>
            </tr> -->
          </tbody>
        </table>

        <div style="text-align: left; margin-left: 0px;border-bottom: 1px solid darkgray;margin-top: 20px; height: 35px;">
          <h3 class="inline font-bold">
            Aconto
          </h3>
        </div>
        <table style="width: 100%;background-color: white;" v-if="salaryReportList.onAccountSalaryRows">
          <tbody v-for="row in salaryReportList.onAccountSalaryRows" :value="row.value" :key="row.value">
            <tr v-show="(showEmpty || row.newLine || row.filteredTotal !== 0) && row.identifier !== 'Total' && row.isSelected">
              <td class="row-name" style="text-align: left;width:400px">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.reportRowName }}</span>
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px">
                {{ row.filteredUnits | salarydecimal }}
              </td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right;">
                <span v-if="!(row.newLine || row.isUserDefined) || !isAdmin || false === canEdit">{{ row.rate | salarydecimal }}</span>
              </td>
              <td style="text-align: right;">
                <span v-if="isAdmin === false || false === canEdit || !row.isUserDefined">{{ row.filteredTotal | salarydecimal }}</span>
                DKK
              </td>
            </tr>
            <tr v-show="row.identifier === 'Total' && row.isSelected" style="border-bottom: 2px solid black; border-top: 1px solid darkgray; font-weight: bold;">
              <td class="row-name" style="text-align: left; width:400px">
                {{ row.reportRowName }}
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px"></td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right;"></td>
              <td style="text-align: right;">{{ row.filteredTotal | salarydecimal }} DKK</td>
            </tr>
          </tbody>
        </table>

        <h3 style="text-align: left; margin-left: 0px;font-weight: bold;border-bottom: 1px solid darkgray;margin-top: 25px;">
          Gennemsnitlig
        </h3>
        <table style="width: 100%;background-color: lightgray;" v-if="salaryReportList.averageRows">
          <tbody v-for="row in salaryReportList.averageRows" :value="row.value" :key="row.value">
            <tr v-show="(showEmpty || row.times > 0) && row.identifier !== 'Total' && row.isSelected" v-bind:title="row.toolTip">
              <td class="row-name" style="text-align: left;width:400px">{{ row.reportRowName }}</td>
              <td style="text-align: right; width: 55px;padding: 0px 5px" v-bind:style="{ background: row.timesBackground }">
                <span v-if="isAdmin === false || false === canEdit">{{ row.filteredUnits | nodecimal }} </span>
              </td>
              <td style="text-align: left; width: 55px;" v-bind:style="{ background: row.timesBackground }">
                {{ row.isMinutes ? (row.type ? row.type : "min.") : row.type ? row.type : "gange" }}
              </td>
              <td style="text-align: right;" v-bind:class="row.calculateGroup">{{ row.rate | salarydecimal }}</td>
              <td style="text-align: right;"></td>
            </tr>
            <tr v-show="row.identifier === 'Total' && row.isSelected" style="border-bottom: 2px solid black; border-top: 1px solid darkgray; font-weight: bold;">
              <td class="row-name" style="text-align: left; width:400px">
                {{ row.reportRowName }}
              </td>
              <td style="text-align: right; width: 55px;padding: 0px 5px"></td>
              <td style="text-align: left; width: 55px;"></td>
              <td style="text-align: right;"></td>
              <td style="text-align: right;">{{ row.filteredTotal | salarydecimal }} DKK</td>
            </tr>
            <!-- <tr>
              <td>{{ row }}</td>
            </tr> -->
          </tbody>
        </table>
      </div>
    </template>
    <csv-modal></csv-modal>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import APISTATE from "@/enums/APISTATE";
  import YearMonthPanel from "@/components/report/YearMonthPanel.vue";
  import SubmitPanel from "@/components/report/SubmitPanel.vue";
  import CsvModal from "@/components/common/CsvModal.vue";
  import DaySelectDropdown from "@/components/common/DaySelectDropdown.vue";
  import moment from "moment";
import { set } from "lodash";

  export default {
    name: "salary-report-view",
    components: {
      YearMonthPanel,
      /* EmployeesPanel, */
      /*       SalaryTypePanel, */
      SubmitPanel,
      CsvModal,
      DaySelectDropdown,
    },
    data: () => ({
      saving: false,
      salaryTypeId: undefined,
      selectedSalaryTypes: [],
      selectedEmployees: [],
      showPanel: true,
      isLoading: false,
      n: 0,
      salaryGroups: [],
      markedSalaryTypes: [],
      markedEmployees: [],
      adminNumbers: ['1016', '1010', '1011']
    }),
    async mounted() {
      this.initYearMonth();
      this.setFromDate(new Date());
      this.setToDate(new Date());
      const number = this.currentUser.number.toString();
      console.log(this.currentUser.isSalaryReportOpen);
      console.log(this.currentUser);
      if (this.adminNumbers.find(f => f === number)) {
        this.loadEmployees()
      } else {
        this.$router.push("/reports");
      }
    },
    methods: {
      ...mapActions("salaryReportStore", [
        "processReportSalaryTotal", 
        "setShowFilterEmployee", 
        "lockReportSalaryEmployee", 
        "unlockReportSalaryEmployee", 
        "updateReportSalaryEmployee", 
        "initYearMonth", 
        "setMonth", 
        "setYear", 
        "setToMonth", 
        "setToYear", 
        "setEmployeeNumber", 
        "addNewLine", 
        "performLookupTotal", 
        "setShowYearTotal", 
        "setCompareDate", 
        "setShowEmpty", 
        "setShowToDate", 
        "setFromDate", 
        "setToDate", 
        "exportSalaryReportCsv"]),
      ...mapActions("csvModalStore", ["setModalOpen"]),
      ...mapActions("reportStore", [
        "getGeneralReportForPeriod",
        "setGeneralReportForPeriod",
      ]),
      ...mapActions("generalStatisticsFilteringSidebar", [
        "sidebarOpenAsync",
        "setIsOpen",
        "setGroupMembers",
        "setFilter",
      ]),
      ...mapActions("salaryTypeFilteringSidebar", [
        "salarySidebarOpenAsync",
        "setSalaryIsOpen",
        "setSalaryTypes",
        "setSalaryFilter",
      ]),
      ...mapActions("employees", [
        "loadEmployees"
      ]),
      async setFilterEmployee() {
        if (!this.groupMembers ||this.groupMembers.length === 0) {
          this.setGroupMembers(this.employees);
        }

        await this.sidebarOpenAsync()
          .then(async (response) => {
            if (response.action === "update") {
              this.markedEmployees = response && response.markedGroupMembers ? response.markedGroupMembers : []
              this.applySalaryFilters()
            }
          })
          .catch((error) => console.error(error));
      },
      async setFilterSalary () {
        this.setSalaryTypes(this.salaryReportList.mergedRows);
        await this.salarySidebarOpenAsync()
          .then(async (response) => {
            if (response.action === "update") {
              this.markedSalaryTypes = response && response.markedSalaryTypes ? response.markedSalaryTypes : []
              this.applySalaryFilters()
            }
          })
          .catch((error) => console.error(error));
      },
      updateSalaryRowProperties(row, employees, types) {
        row.isSelected = true
        if (employees && employees.length > 0) {
          row.isSelected = row.employees && row.employees.filter(o => employees.filter(emp => emp.number === o.number).length > 0).length > 0;
        }

        if (row.isSelected && types && types.length > 0) {
          row.isSelected = types.filter(o => o.reportRowName == row.reportRowName).length > 0;
        }

        if (false === row.isSelected) {
          return;
        }

        if (!employees || employees.length === 0) {          
          row.filteredUnits = row.isMinutes ? row.minutes : row.times
          row.filteredTotal = row.total
          row.isNotZeroValue = row.filteredTotal != 1;
          
          if (row.isNotZeroValue) {            
            row.filteredRate = row.total / row.filteredUnits;
          }

          return;
        }

        row.filteredUnits = 0
        row.filteredTotal = 0
        row.employees.forEach(em => {
          if(employees.filter(emp => emp.number === em.number).length > 0){
            row.filteredUnits += em.units
            row.filteredTotal += em.total
          }
        });
        row.isNotZeroValue = row.filteredTotal != 1;
        
        if (row.isNotZeroValue) {            
          row.filteredRate = row.total / row.filteredUnits;
        }
      },
      applySalaryFilters() {
        const employees = this.markedEmployees
        const types = this.markedSalaryTypes
        this.salaryReportList.partialSumRows.forEach((agm) => {
          this.updateSalaryRowProperties(agm, employees, types);
        });
        this.salaryReportList.payrollRows.forEach((agm) => {
          this.updateSalaryRowProperties(agm, employees, types);
        });
        this.salaryReportList.general.forEach((agm) => {
          this.updateSalaryRowProperties(agm, employees, types);
        });
        this.salaryReportList.totalSalaryRows.forEach((agm) => {
          this.updateSalaryRowProperties(agm, employees, types);
        });
        this.salaryReportList.onAccountSalaryRows.forEach((agm) => {
          this.updateSalaryRowProperties(agm, employees, types);
        });
        this.salaryReportList.averageRows.forEach((agm) => {
          this.updateSalaryRowProperties(agm, employees, types);
        });
      },
      getDateFromMonthYear(day, month, year) {
        let date = new Date();
        date.setMonth(month);
        date.setFullYear(year);
        date.setDate(day);
        return date;
      },
      getLatestDayOfMonth(month, year) {
        return new Date(year, month + 1, 0).getDate();
      },
      testDate() {
        return {
          fromDate: this.getDateFromMonthYear(1, 11, 2021),
          toDate: this.getDateFromMonthYear(this.getLatestDayOfMonth(11, 2021), 11, 2021),
        };
      },
      async fetchAndApplyFilter() {
        this.isLoading = true
        await this.performLookupTotal()

        if (!this.markedEmployees || this.markedEmployees.length === 0) {          
          this.markedEmployees = this.employees
        }

        setTimeout(() => {
          this.applySalaryFilters()
        }, 1000)
        this.isLoading = false
      },
      async modelUpdated() {
        this.fetchAndApplyFilter()
      },
      async updateEmployeeData() {
        this.salaryReportList.isYear = this.showYear;
        await this.updateReportSalaryEmployee(this.salaryReportList);
        this.fetchAndApplyFilter()
      },
      specialAllowanceCanBeEdited(reportRowName) {
        if (this.canEdit && (reportRowName === "Særlig feriegodtgørelse - 31/5" || reportRowName === "Særlig feriegodtgørelse - 31/8") && (this.salaryReportList.month === 5 || this.salaryReportList.month === 8 || this.showYear)) {
          return true;
        }
      },
      async exportSalaryCsv() {
        let fromDate = this.getDateFromMonthYear(1, this.salaryReportFilterMonth, this.salaryReportFilterYear);
        await this.exportSalaryReportCsv({ date: fromDate });

        if (this.salaryReportCsv && this.salaryReportCsv.length > 0) {
          const csvData = [];
          this.salaryReportCsv.forEach((element) => {
            csvData.push({
              "Ins.": element.employeeNumber,
              År: element.year,
              Aconto: element.onAccountSalary,
              Beregnet: element.calculatedSalary,
              Supplement: element.supplementSalary,
              "Total Rest": element.restSalary,
              Dagsløn: element.averageDaySalary,
            });
          });

          const blob = new Blob([this.arrayToCsv(csvData)], { type: "text/csv;charset=utf-8" });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "salary_report.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      },
      arrayToCsv(data, delimiter = ";") {
        // Opret en header-række baseret på arrayets nøgler
        const header = Object.keys(data[0]).join(delimiter);

        // Opret data-rækker
        const rows = data.map((row) =>
          Object.values(row)
            .map((value) => (typeof value === "string" && value.includes(delimiter) ? `"${value}"` : typeof value === "number" && !isNaN(value) && value.toString().includes(".") ? new Intl.NumberFormat("da-DK").format(value) : value))
            .join(delimiter)
        );

        // Saml header og data-rækker
        return [header, ...rows].join("\n");
      },
      async navigateInWeeks(numberOfWeeks) {
        // IGNORE
      },
      formatDate(date) {
        return moment(date).format("YYYY-MM-DD");
      },
      setDate(arg, type) {
        if (!arg) {
          return;
        }

        if (type == 0) {
          this.setFromDate(moment(arg).toDate());
        } else {
          this.setToDate(moment(arg).toDate());
        }
      },
      exportCsv(isUnits) {
        const employees = this.markedEmployees
        const data = []
        this.salaryReportList.partialSumRows.forEach(row => {
          if (row.isSelected) {
            row.employees.forEach(emp => {
              if(employees.length === 0 || employees.find(f => f.number === emp.number)) {
                data.push({ 
                  employeeNumber: emp.number, 
                  column: row.reportRowName, 
                  value: isUnits ? emp.units.toString().replace('.', ',') : emp.total.toString().replace('.', ',')  
                })
              }
            });
          }
        });
        
        this.salaryReportList.payrollRows.forEach(row => {
          if (row.isSelected) {
            row.employees.forEach(emp => {
              if(employees.length === 0 || employees.find(f => f.number === emp.number)) {
                data.push({ 
                  employeeNumber: emp.number, 
                  column: row.reportRowName, 
                  value: isUnits ? emp.units.toString().replace('.', ',') : emp.total.toString().replace('.', ',')  
                })
              }
            });
          }
        });
        
        this.salaryReportList.general.forEach(row => {
          if (row.isSelected) {
            row.employees.forEach(emp => {
              if(employees.length === 0 || employees.find(f => f.number === emp.number)) {
                data.push({ 
                  employeeNumber: emp.number, 
                  column: row.reportRowName, 
                  value: isUnits ? emp.units.toString().replace('.', ',') : emp.total.toString().replace('.', ',')  
                })
              }
            });
          }
        });
        
        this.salaryReportList.totalSalaryRows.forEach(row => {
          if (row.isSelected) {
            row.employees.forEach(emp => {
              if(employees.length === 0 || employees.find(f => f.number === emp.number)) {
                data.push({ 
                  employeeNumber: emp.number, 
                  column: row.reportRowName, 
                  value: isUnits ? emp.units.toString().replace('.', ',') : emp.total.toString().replace('.', ',')  
                })
              }
            });
          }
        });
        
        this.salaryReportList.onAccountSalaryRows.forEach(row => {
          if (row.isSelected) {
            row.employees.forEach(emp => {
              if(employees.length === 0 || employees.find(f => f.number === emp.number)) {
                data.push({ 
                  employeeNumber: emp.number, 
                  column: row.reportRowName, 
                  value: isUnits ? emp.units.toString().replace('.', ',') : emp.total.toString().replace('.', ',')  
                })
              }
            });
          }
        });
        
        this.salaryReportList.averageRows.forEach(row => {
          if (row.isSelected) {
            row.employees.forEach(emp => {
              if(employees.length === 0 || employees.find(f => f.number === emp.number)) {
                data.push({ 
                  employeeNumber: emp.number, 
                  column: row.reportRowName, 
                  value: isUnits ? emp.units.toString().replace('.', ',') : emp.total.toString().replace('.', ',')  
                })
              }
            });
          }
        });
        // Get all unique columns
        const columns = ['Employee Number', ...new Set(data.map(item => item.column))];

        const transformedData = data.reduce((acc, item) => {
          if (!acc[item.employeeNumber]) {
            acc[item.employeeNumber] = { 'Employee Number': item.employeeNumber };
          }
          acc[item.employeeNumber][item.column] = item.value;
          return acc;
        }, {});

        const csvArray = Object.values(transformedData).map(row => {
          return columns.map(col => row[col] || '');
        });

        const csvContent = [
          columns,
          ...csvArray
        ].map(e => e.join(";")).join("\n");
        
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        const utf8BOM = '\uFEFF';
        const csvFile = new Blob([utf8BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
        const downloadLink = document.createElement('a');
        const type = isUnits ? 'Lønrapport - Enheder - ' :  'Lønrapport - DKK - ';
        downloadLink.download = type + this.salaryReportFilterYear + '-' + this.salaryReportFilterMonth + '.csv';
        if (this.showToDate) {
          downloadLink.download = type + new Date(this.fromDate).toLocaleDateString('da-DK', options) + '-' + new Date(this.toDate).toLocaleDateString('da-DK', options) + '.csv';
        }
        if (this.isYear) {
          downloadLink.download = type + 'Årsrapport - ' + this.salaryReportFilterYear + '.csv';
        }
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = 'none';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    },
    computed: {
      ...mapGetters("salaryReportStore", ["salaryReportFilterEmployeeNumber", "showFilterEmployee", "salaryReportFilterMonth", "salaryReportFilterYear", "salaryReportApiState", "salaryReportList", "showYear", "compareDate", "showEmpty", "showToDate", "fromDate", "toDate", "toDate", "salaryReportCsv"]),
      ...mapGetters(["currentUser", "isAdmin"]),
       ...mapGetters("reportStore", [
        "generalReportForPeriodApiState",
        "generalReportForPeriod",
      ]),
      ...mapGetters("generalStatisticsFilteringSidebar", ["filter", "groupMembers"]),
      ...mapGetters("salaryTypeFilteringSidebar", ["filter"]),
      ...mapGetters("employees", ["employees"]),
      loading() {
        return this.salaryReportApiState === APISTATE.LOADING && this.generalReportForPeriodApiState === APISTATE.LOADING;
      },
      hasData() {
        return this.salaryReportList && this.salaryReportList.totalSalaryRows && this.salaryReportList.totalSalaryRows.length > 0;
      },
      getFromDate() {
        return this.fromDate;
      },
      getToDate() {
        return this.toDate;
      },
      canEdit() {
        return false;
      },
    },
  };
</script>

<style lang="scss">
  a.dropdown-item,
  .dropdown .dropdown-menu .has-link a,
  button.dropdown-item {
    text-align: left;
  }

  .upload-button {
    display: flex;
    align-items: flex-end;
    padding-bottom: 4px;
  }

  .total-rows {
    background-color: hsl(33, 75%, 78%) !important;
  }

  .upload-button {
    display: flex;
    align-items: flex-end;
    padding-bottom: 4px;
  }

  .upload-button {
    display: flex;
    align-items: flex-end;
    padding-bottom: 4px;
  }

  input[type="number"] {
    max-width: 100px;
    border-radius: 5px;
    padding: 2px 3px;
  }

  .salaryreports__report__view {
    background: #d3d3d34a;
  }

  .wrapper {
    max-width: 800px;
    margin: auto 25%;
    background: white;
    padding: 10px;
    height: 80vh;
  }
  td,
  th {
    font-size: 12px;
    height: 28px;
    vertical-align: middle;
  }

  .AVG {
    background: lightblue;
  }

  .AVGEXTRA {
    background: #d6f3d6;
  }

  .schedule__daynavigator {
    top: 18px;
    position: relative;
    .dayselectdropdown {
      .dayselectdropdown__dropdown {
        right: -156px !important;

        .dayselectdropdown__dayspanel {
          box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
        }
      }
    }
  }
  .schedule__daynavigator > .dayselectdropdown > .dayselectdropdown__dropdown {
    right: -156px !important;
  }

  .control-button {
    width: 120px;
    background: #adadad;
    border: 1px solid #bbb;
    border-radius: 3px;
    color: white;
    cursor: pointer;
    float: left;
    font-size: 14px;
    font-weight: 500;
    height: 29px;
    line-height: 27px;
    text-align: center;
    text-decoration: none;
  }

  @media print {
    .wrapper {
      max-width: 100%;
      margin: auto auto;
    }
    .total-rows {
      background-color: hsl(33, 75%, 78%) !important;
    }

    .no-print {
      display: none;
    }

    .row-name {
      width: 55% !important;
    }
  }
  .table-header-container {
    text-align: left;
    margin-left: 0px;
    font-weight: bold;
    border-bottom: 1px solid darkgray;
    margin-top: 20px;
    height: 35px;
  }

  .inline {
    display: inline-block;
  }

  .font-bold {
    font-weight: bold;
  }
</style>